/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from 'react'
import ReactMarkdown from 'react-markdown'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'

type RMarkdownProps = {
  rawText: string
}

const RMarkdown = ({ rawText }: RMarkdownProps) => {
  return (
    <ReactMarkdown
      components={{
        h1: ({ children }) => (
          <HeadingNew
            color="neutral900"
            size="large"
            weight="bold"
            style={{ marginBottom: '8px' }}
          >
            {children}
          </HeadingNew>
        ),
        h2: ({ children }) => (
          <HeadingNew
            color="neutral900"
            size="medium"
            weight="bold"
            style={{ marginBottom: '8px' }}
          >
            {children}
          </HeadingNew>
        ),
        h3: ({ children }) => (
          <HeadingNew
            color="neutral900"
            size="small"
            weight="bold"
            style={{ marginBottom: '8px' }}
          >
            {children}
          </HeadingNew>
        ),
        p: ({ children }) => (
          <SupportTextNew
            color="neutral900"
            size="xsmall"
            weight="normal"
            style={{ marginBottom: '8px' }}
          >
            {children}
          </SupportTextNew>
        ),
        strong: ({ children }) => (
          <strong style={{ fontWeight: 600 }}>{children}</strong>
        ),
        ul: ({ children }) => (
          <ul style={{ margin: '16px 0', paddingLeft: '24px' }}>{children}</ul>
        ),
        li: ({ children }) => (
          <li style={{ padding: 0, margin: 0 }}>
            <SupportTextNew color="neutral900" size="xsmall" weight="normal">
              {children}
            </SupportTextNew>
          </li>
        )
      }}
    >
      {rawText}
    </ReactMarkdown>
  )
}

export default RMarkdown
